import { render, staticRenderFns } from "./rjQuickBasicInformation.vue?vue&type=template&id=43bdc84d&scoped=true"
import script from "./rjQuickBasicInformation.vue?vue&type=script&lang=js"
export * from "./rjQuickBasicInformation.vue?vue&type=script&lang=js"
import style0 from "./rjQuickBasicInformation.vue?vue&type=style&index=0&id=43bdc84d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bdc84d",
  null
  
)

export default component.exports